module.exports = {
  selectLanguage: "Ви обрали українську",
  paintSize: "Розмір",
  paintYear: "Рік",
  paintMethod: "Техніка",
  loadMore: "Завантажити ще",
  backlink: "Повернутись",
  filterValueAll: "усі",
  filterFrom: "з",
  authorName: "Віктор",
  authorSurame: "Виноградов",
  authorFullname: "Віктор Виноградов",
  seoDescr: "Віктор Виноградов - видатний український художник і поет",
  seoDescr2: "Купити картину Виноградова",
  btnAddCart: "Придбати",
  btnRemoveFromCart: "Видалити з кошика",
  btnReserCart: "Очистити",
  yourName: "ваше ім'я",
  yourEmail: "ваш email",
}
